import { camelCase, flatMap, set } from "lodash-es";
export function tableQueryParamsToHasuraClauses({
  page,
  pageSize,
  searchTerm,
  filters,
  order,
  schema,
  // Add schema as a parameter
  additionalFilter
}) {
  const ccFields = getFieldsMappedByCCDisplayName(schema);
  let where = {};
  const order_by = [];
  const limit = pageSize || 25;
  const offset = page && pageSize ? (page - 1) * pageSize : 0;
  if (searchTerm) {
    const searchTermFilters = [];
    const uniqueFieldsByPath = {};
    const searchTerms = searchTerm.split(",");
    schema.fields.forEach((field) => {
      const {
        type,
        path,
        additionalSearchPaths = [],
        searchDisabled,
        isHidden
      } = field;
      const allPaths = [path, ...additionalSearchPaths];
      allPaths.forEach((path2) => {
        addSearchTermFilters(path2);
      });
      function addSearchTermFilters(path2) {
        if (uniqueFieldsByPath[path2]) return;
        uniqueFieldsByPath[path2] = true;
        if (searchDisabled || field.filterDisabled || type === "color" || isHidden || !path2)
          return;
        searchTerms.forEach((term) => {
          const filterValue = term.trim();
          if (type === "string" || type === "lookup") {
            const o = set({}, path2, { _ilike: `%${filterValue}%` });
            searchTermFilters.push(o);
          } else if (type === "boolean") {
            let regex;
            try {
              regex = new RegExp("^" + filterValue, "ig");
            } catch (error) {
            }
            if (regex) {
              if ("true".replace(regex, "") !== "true") {
                const o = set({}, path2, { _eq: true });
                searchTermFilters.push(o);
              } else if ("false".replace(regex, "") !== "false") {
                const o = set({}, path2, { _eq: false });
                searchTermFilters.push(o);
              }
            }
          } else if ((type === "number" || type === "integer") && !isNaN(filterValue)) {
            const o = set({}, path2, { _eq: parseFloat(filterValue) });
            searchTermFilters.push(o);
          }
        });
      }
    });
    if (searchTermFilters.length > 0) {
      if (Object.keys(where).length > 0) {
        where = { _and: [where, { _or: searchTermFilters }] };
      } else {
        where = { _or: searchTermFilters };
      }
    }
  }
  if (filters && filters.length > 0) {
    const filterClauses = flatMap(filters, (filter) => {
      let { selectedFilter, filterOn, filterValue } = filter;
      const fieldSchema = ccFields[filterOn] || {};
      const {
        path,
        additionalSearchPaths = [],
        reference,
        type,
        customColumnFilter
      } = fieldSchema;
      if (customColumnFilter) {
        return customColumnFilter(filterValue);
      }
      let stringFilterValue = filterValue && filterValue.toString ? filterValue.toString() : filterValue;
      if (stringFilterValue === false) {
        stringFilterValue = "false";
      } else {
        stringFilterValue = stringFilterValue || "";
      }
      const arrayFilterValue = Array.isArray(filterValue) ? filterValue : stringFilterValue.split(";");
      if (type === "number" || type === "integer") {
        filterValue = Array.isArray(filterValue) ? filterValue.map((val) => Number(val)) : Number(filterValue);
      }
      if (fieldSchema.normalizeFilter) {
        filterValue = fieldSchema.normalizeFilter(
          filterValue,
          selectedFilter,
          filterOn
        );
      }
      if (reference) {
        filterOn = reference.sourceField;
        return addColumnFilters(filterOn);
      } else {
        if (path) {
          const allPaths = [path, ...additionalSearchPaths];
          if (allPaths.length > 1) {
            return { _or: allPaths.map((p) => addColumnFilters(p)) };
          }
          return allPaths.map((p) => addColumnFilters(p));
        } else {
          return addColumnFilters(filterOn);
        }
      }
      function addColumnFilters(filterOn2) {
        switch (selectedFilter) {
          case "none":
            return {};
          case "startsWith":
            return { [filterOn2]: { _ilike: `${filterValue}%` } };
          case "endsWith":
            return { [filterOn2]: { _ilike: `%${filterValue}` } };
          case "contains":
            return { [filterOn2]: { _ilike: `%${filterValue}%` } };
          case "notContains":
            return { [filterOn2]: { _nilike: `%${filterValue}%` } };
          case "isExactly":
            return { [filterOn2]: { _eq: filterValue } };
          case "isEmpty":
            if (filterOn2.includes(".")) {
              return {
                _not: {
                  [filterOn2.split(".")[0]]: {}
                }
              };
            }
            return {
              _or: [
                { [filterOn2]: { _eq: "" } },
                { [filterOn2]: { _is_null: true } }
              ]
            };
          case "notEmpty":
            return {
              _and: [
                { [filterOn2]: { _neq: "" } },
                { [filterOn2]: { _is_null: false } }
              ]
            };
          case "inList":
            return { [filterOn2]: { _in: filterValue } };
          case "notInList":
            return { [filterOn2]: { _nin: filterValue } };
          case "true":
            return { [filterOn2]: { _eq: true } };
          case "false":
            return { [filterOn2]: { _eq: false } };
          case "dateIs":
            return { [filterOn2]: { _eq: filterValue } };
          case "notBetween":
            return {
              _or: [
                {
                  [filterOn2]: {
                    _lt: new Date(arrayFilterValue[0])
                  }
                },
                {
                  [filterOn2]: {
                    _gt: new Date(
                      new Date(arrayFilterValue[1]).setHours(23, 59)
                    )
                  }
                }
              ]
            };
          case "isBetween":
            return {
              [filterOn2]: {
                _gte: new Date(arrayFilterValue[0]),
                _lte: new Date(new Date(arrayFilterValue[1]).setHours(23, 59))
              }
            };
          case "isBefore":
            return { [filterOn2]: { _lt: new Date(filterValue) } };
          case "isAfter":
            return { [filterOn2]: { _gt: new Date(filterValue) } };
          case "greaterThan":
            return { [filterOn2]: { _gt: parseFloat(filterValue) } };
          case "lessThan":
            return { [filterOn2]: { _lt: parseFloat(filterValue) } };
          case "inRange":
            return {
              [filterOn2]: {
                _gte: parseFloat(arrayFilterValue[0]),
                _lte: parseFloat(arrayFilterValue[1])
              }
            };
          case "outsideRange":
            return {
              _or: [
                {
                  [filterOn2]: {
                    _lt: parseFloat(arrayFilterValue[0])
                  }
                },
                {
                  [filterOn2]: {
                    _gt: parseFloat(arrayFilterValue[1])
                  }
                }
              ]
            };
          case "equalTo":
            return {
              [filterOn2]: {
                _eq: type === "number" || type === "integer" ? parseFloat(filterValue) : filterValue
              }
            };
          case "regex":
            return { [filterOn2]: { _regex: filterValue } };
          default:
            console.warn(`Unsupported filter type: ${selectedFilter}`);
            return {};
        }
      }
    });
    if (filterClauses.length > 0) {
      if (Object.keys(where).length > 0) {
        where = { _and: [where, ...filterClauses] };
      } else {
        where = { _and: filterClauses };
      }
    }
  }
  if (order && order.length > 0) {
    order.forEach((item) => {
      const field = item.startsWith("-") ? item.substring(1) : item;
      const direction = item.startsWith("-") ? "desc" : "asc";
      order_by.push({ [field]: direction });
    });
  }
  if (additionalFilter) {
    where = { _and: [where, additionalFilter] };
  }
  return { where, order_by, limit, offset };
}
export function getFieldsMappedByCCDisplayName(schema) {
  if (!schema || !schema.fields) return {};
  return schema.fields.reduce((acc, field) => {
    const ccDisplayName = getCCDisplayName(field);
    acc[ccDisplayName] = field;
    return acc;
  }, {});
}
export function getCCDisplayName(field) {
  return camelCase(
    typeof field.displayName === "string" ? field.displayName : field.path
  );
}
